@if (hasSlides) {
  <section
    class="campaign-carousel"
    aria-roledescription="carousel"
    [attr.aria-label]="'campaign-carousel.aria-label' | translate"
    (mouseenter)="pauseAutoAdvance()"
    (mouseleave)="resumeAutoAdvance()"
    (focusin)="pauseAutoAdvance()"
    (focusout)="resumeAutoAdvance()">
    <div class="campaign-carousel__art">
      <div class="campaign-carousel__art-track" [style.transform]="trackTransform">
        @for (slide of slides; track slide.id; let index = $index) {
          <div class="campaign-carousel__art-slide" [attr.aria-hidden]="!isActive(index)">
            <img
              class="campaign-carousel__image"
              loading="lazy"
              [src]="slide.imageUrl"
              [alt]="'campaign-carousel.image-alt' | translate: { title: slide.title }" />
          </div>
        }
      </div>
    </div>

    <div class="campaign-carousel__content">
      <div class="campaign-carousel__text-viewport">
        <div class="campaign-carousel__text-track" [style.transform]="trackTransform">
          @for (slide of slides; track slide.id; let index = $index) {
            <article
              class="campaign-carousel__text-slide"
              role="group"
              aria-roledescription="slide"
              [attr.aria-hidden]="!isActive(index)"
              [attr.aria-label]="
                'campaign-carousel.slide-position' | translate: { current: index + 1, total: slides.length }
              ">
              @if (formatDate(slide)) {
                <p class="campaign-carousel__meta">
                  <i class="agres-calendar" aria-hidden="true"></i>
                  <span>{{ formatDate(slide) }}</span>
                </p>
              }

              <h3 class="campaign-carousel__title">{{ slide.title }}</h3>

              <p class="campaign-carousel__description">{{ slide.description }}</p>

              <button
                type="button"
                class="campaign-carousel__action"
                [attr.tabindex]="slideTabIndex(index)"
                (click)="openSlide(slide)">
                {{ 'campaign-carousel.view-action' | translate }}
                <i class="agres-arrow-right" aria-hidden="true"></i>
              </button>
            </article>
          }
        </div>
      </div>

      @if (hasMultipleSlides) {
        <footer class="campaign-carousel__footer">
          <div class="campaign-carousel__pages">
            @for (slide of slides; track slide.id; let index = $index) {
              <button
                type="button"
                class="campaign-carousel__page"
                [class.campaign-carousel__page--active]="isActive(index)"
                [attr.aria-current]="isActive(index)"
                [attr.aria-label]="
                  'campaign-carousel.go-to-slide' | translate: { current: index + 1, total: slides.length }
                "
                (click)="goTo(index)">
                {{ index + 1 }}
              </button>
            }
          </div>

          <div class="campaign-carousel__controls">
            <button
              type="button"
              class="campaign-carousel__control"
              [attr.aria-label]="'campaign-carousel.previous' | translate"
              (click)="previous()">
              <i class="agres-arrow-left" aria-hidden="true"></i>
            </button>

            <button
              type="button"
              class="campaign-carousel__control"
              [attr.aria-label]="'campaign-carousel.next' | translate"
              (click)="next()">
              <i class="agres-arrow-right" aria-hidden="true"></i>
            </button>
          </div>
        </footer>
      }
    </div>
  </section>
}
